import { Component } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import Form from 'Lib/components/form/Form';
import isFunction from 'Lib/utilities/isFunction';

import PromptModal from '../modals/PromptModal';

class FormPanel extends Component {
	state = {
		isConfirming: false,
		form: null
	};

	close = isSubmitting => {
		if (isSubmitting) {
			return;
		}

		if (isFunction(this.props.onClose)) {
			this.props.onClose();
		}
	};

	toggleConfirm = () => {
		this.setState(prevState => ({
			isConfirming: !prevState.isConfirming
		}));
	};

	handleSubmit = (e, form, confirmed = false) => {
		const { confirm } = this.props;

		if (confirm && !confirmed) {
			this.setState({
				form
			});

			e.preventDefault();
			this.toggleConfirm();
		} else {
			if (form.isSubmitting) {
				e.preventDefault();

				return;
			}

			if (confirm) {
				this.toggleConfirm();
			}

			form.handleSubmit(e);
		}
	};

	renderButtons = props => {
		const { buttons, create, disabled, isForm = true } = this.props;

		if (isFunction(buttons)) {
			return buttons({
				...props,
				onClose: () => this.close(props.isSubmitting)
			});
		} else if (Array.isArray(buttons)) {
			return buttons.map((item, index) => {
				return <span key={index}>{item}</span>;
			});
		}

		if (props.isSubmitting) {
			return (
				<Button color="primary" disabled={true}>
					Saving...
				</Button>
			);
		}

		return isForm ? (
			<div className="button-panel">
				<Button onClick={() => this.close(props.isSubmitting)}>Cancel</Button>
				<Button
					type={create ? 'button' : 'submit'}
					disabled={disabled}
					style={{ marginRight: '6px' }}
					color="primary"
					onClick={create ? () => this.props.onCreate(props.values) : null}>
					{create ? 'Create' : 'Save'}
				</Button>
			</div>
		) : (
			<Button onClick={() => this.close(props.isSubmitting)}>Close</Button>
		);
	};

	renderBody = props => {
		const { render } = this.props;

		if (isFunction(render)) {
			return render(props);
		}

		return this.props.children;
	};

	renderConfirmModal = () => {
		const { isConfirming, form } = this.state;
		const { confirm, confirmText: { color = 'success', confirmAction = 'Confirm', confirmProcessing = 'Confirming', header } = {} } = this.props;

		return (
			<PromptModal
				isOpen={isConfirming}
				onClose={this.toggleConfirm}
				header={header}
				buttons={prompt => {
					if (prompt.isProcessing) {
						return (
							<Button color={color} disabled={true}>
								{confirmProcessing}...
							</Button>
						);
					}

					return (
						<>
							<Button color={color} onClick={e => this.handleSubmit(e, form, true)}>
								{confirmAction}
							</Button>
							<Button color="secondary" onClick={prompt.close}>
								Cancel
							</Button>
						</>
					);
				}}>
				{isFunction(confirm) ? confirm() : confirm}
			</PromptModal>
		);
	};

	render() {
		const { isOpen, buttonOverride, header, mode, ...rest } = this.props;

		return (
			<>
				<Form
					{...rest}
					render={form => {
						const toggle = () => this.close(form.isSubmitting);
						let className = 'form-panel';

						if (mode == 'full') {
							className += ' full';
						}

						return (
							<Modal className={className} modalClassName="modal-reactstrap" fade={true} isOpen={isOpen} toggle={toggle} keyboard={true}>
								<form onSubmit={e => this.handleSubmit(e, form)}>
									<div className="form-panel-body">
										<ModalHeader toggle={toggle}>{isFunction(header) ? header() : header}</ModalHeader>
										<ModalBody>{this.renderBody(form)}</ModalBody>
										<ModalFooter>{!buttonOverride && this.renderButtons(form)}</ModalFooter>
									</div>
								</form>
							</Modal>
						);
					}}
				/>
				{this.renderConfirmModal()}
			</>
		);
	}
}

export default FormPanel;
